import { InviteStatus } from '@shared/invite/enums';
import { DropdownFilterItem } from '@tablesready/common-ui';

export const InviteStatuses: DropdownFilterItem<InviteStatus>[] = [
  {value: InviteStatus.expired, title: 'Expired'},
  {value: InviteStatus.declined, title: 'Declined'},
  {value: InviteStatus.pending, title: 'Pending'},
];
